import { Component, Input, OnDestroy, Output } from '@angular/core';

import { InputsModule } from "@progress/kendo-angular-inputs";

import { QueryPanelSummaryItem } from 'src/app/modules/fwcore/models';
import { QueryPanelConnectorService } from 'src/app/modules/fwcore/services';

@Component({
  selector: 'numeric-textbox-criteria',
  standalone: true,
  styleUrls: ['./numeric-textbox-criteria.component.scss'],
  templateUrl: './numeric-textbox-criteria.component.html',
  imports: [InputsModule]
})

export class NumericTextBoxCriteriaComponent
  implements OnDestroy {
  /*-------------------------- Input / Outputs --------------------------------*/
  @Input() format: string = "n2";
  @Input() minimum: number = 0;
  @Input() maximum: number = 100;
  @Input() caption: string = "";
  @Input() suffix: string = "";

  protected textBoxValue: any;

  /*-------------------------- Input / Output ------------------*/
  @Output() get value(): number | null {
    if (!isNaN(this.textBoxValue)) {
      return this.textBoxValue;
    }
    return null;
  }
  @Input() set default(val: number | null) {
    this.textBoxValue = val;
  }

  /* ------------------------ Internal properties ------------------------ */
  protected subscription: any;

  /* ------------------------ Constructor ------------------------ */
  constructor (
    protected connectorService: QueryPanelConnectorService) {
    this.subscription = this.connectorService.onMessage().subscribe(message => {
      if (message) {
        switch (message.type) {
          case "clear":
            this.textBoxValue = null;
            break;
          case "load":
            this.connectorService.isLoaded("_");
            break;
          case "delete":
            if (message.item?.controlName == this.caption && !message.isFromTreeView) {
              this.textBoxValue = null;
            }
        }
      }
    });
  }

  /* ------------------------ ng ------------------------ */
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  /* ------------------------ event handlers ------------------------ */
  public onChange(val: string): void {
    let item = new QueryPanelSummaryItem();
    item.controlName = this.caption;
    item.text = this.caption + " " + val?.toString();
    item.id = "0";

    if (val != null) {
      this.connectorService.removeItem(item, true);
      this.connectorService.addItem(item, false);
    } else {
      this.connectorService.removeItem(item, true);
    }
  }
}
